import React from 'react';
import styles from './ThirdScreen.module.css';
import moneyImage from '../recImages/money.jpeg';

const ThirdScreenRec = () => {
  return (
    <section className={styles.container}>
      {/* תת כותרת ראשונה */}
      <p className={styles.subtitleTop}>
        ובשורה התחתונה 
      </p>

      {/* כותרת ראשית עם underline מיוחד */}
      <h2 className={styles.mainTitle}>
        הבנת שאת המנוע מאחורי ההצלחה של אחרים – והגיע הזמן
        להיות המנוע של ההצלחה של עצמך
      </h2>

      {/* תת כותרת שנייה */}
      <p className={styles.subtitle}>
        ואם לשנייה היה לך ספק:
      </p>

      {/* תמונות הוכחות כספיות */}
      <div className={styles.proofImagesContainer}>
        <img src={moneyImage} alt="הוכחות כספיות" className={styles.proofImage} />
      </div>

      {/* תת כותרת שלישית */}
      <p className={styles.subtitle}>
        כן, את לא מדמיינת - אלה הסכומים שאת יכולה להכניס מהתחום
      </p>

      {/* תיאור */}
      <p className={styles.description}>
        למה? כי עסקים היום כבר לא מחפשים רק "מזכירה" או
        פתרון לבעיה נקודתית אחת. הם צמאים למישהי שיודעת לייעל
        תהליכים עבורם, לקחת מהם את כל המשימות שהם לא אוהבים
        לעשות ולהניע את העסק קדימה.
      </p>

     
    </section>
  );
};

export default ThirdScreenRec;
